import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const NavItem = ({ to, icon, children }) => (
  <li className="sidebar-item">
    <NavLink to={to} className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`} title={String(children)}>
      <span className="sidebar-link-icon">{icon}</span>
      <span className="sidebar-link-text">{children}</span>
    </NavLink>
  </li>
);

const Navbar = () => {
  const { user } = useAuth();

  return (
    <nav className="sidebar">
      <div className="sidebar-header">
        <img src="/logo.png" alt="Xaltech Fotos" className="sidebar-logo" />
      </div>

      <ul className="sidebar-menu">
        {!user ? (
          <>
            <NavItem to="/login" icon="🔑">Login</NavItem>
            <NavItem to="/unete-fotografos" icon="📷">Únete como Fotógrafo</NavItem>
          </>
        ) : (
          <>
            <NavItem to="/dashboard" icon="🏠">Dashboard</NavItem>
            {user.tipoUsuario === 'FOTOGRAFO' && (
              <>
                <NavItem to="/eventos" icon="🎟️">Mis Eventos</NavItem>
                <NavItem to="/ventas" icon="💵">Mis Ventas</NavItem>
                <NavItem to="/mi-cuenta" icon="👤">Mi Cuenta</NavItem>
              </>
            )}
            {user.tipoUsuario === 'ADMIN' && (
              <>
                <NavItem to="/ventas" icon="💵">Ventas</NavItem>
                <NavItem to="/admin/fotografos" icon="✅">Aprobar Fotógrafos</NavItem>
                <NavItem to="/admin/pagos" icon="💰">Pagos Fotógrafos</NavItem>
                <NavItem to="/admin/solicitudes-fotografos" icon="📸">Solicitudes Fotógrafos</NavItem>
              </>
            )}
          </>
        )}
      </ul>

      {user && <div className="sidebar-user">Hola, {user.nombreCompleto}</div>}
    </nav>
  );
};

export default Navbar;
